// OrderProgress.jsx
import React, { useEffect, useState } from 'react';
import './OrderProgress.css';
import {
  STATUS_PIPELINE,
  fetchOrderStatuses,
  getDealerProgressStepByStatusLabel,
  getStatusLabelById,
} from '../../utils/statusUtils';

const OrderProgress = ({ statusId }) => {
  const [statusOptions, setStatusOptions] = useState([]);

  useEffect(() => {
    let isMounted = true;
    fetchOrderStatuses()
      .then((statuses) => {
        if (isMounted) {
          setStatusOptions(statuses);
        }
      })
      .catch(() => {});
    return () => {
      isMounted = false;
    };
  }, []);

  const statusLabel = getStatusLabelById(statusOptions, statusId);
  const currentProgress = getDealerProgressStepByStatusLabel(statusLabel);
  
  // Status labels
  const statuses = STATUS_PIPELINE;
  
  // Status colors (matching the image)
  const colors = ['#808080', '#B22222', '#0000CD', '#DAA520'];
  
  return (
    <div className="order-progress">
      <div className="progress-bar">
        {statuses.map((label, index) => (
          <div 
            key={index} 
            className={`progress-segment ${index < currentProgress ? 'completed' : ''}`}
          >
            <div 
              className="progress-shape"
              style={{ backgroundColor: index < currentProgress ? colors[index] : '#e0e0e0' }}
            />
          </div>
        ))}
      </div>
      <div className="progress-labels">
        {statuses.map((label, index) => (
          <div 
            key={index} 
            className={`progress-label ${index < currentProgress ? 'completed' : ''}`}
          >
            {label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderProgress;
